<template>
  <div id="app" class="app">
    <router-view></router-view>
    <whatsapp-connect />

    <consent-banner @triggerLocalCookie="triggerLocalCookie" />
  </div>
</template>

<script>
import WhatsappConnect from './components/WhatsappConnect'
import ConsentBanner from './components/ConsentBanner.vue'

export default {
  name: 'App',
  mounted() {
    this.setReferrer()
    if (this.$consentManager.getConsentValue('preference') === 'AcceptAll') {
      this.triggerLocalCookie()
    }
  },
  methods: {
    triggerLocalCookie() {
      // run scripts here
      this.$analytics.initializeAnalytics()
    },
    setReferrer() {
      const referrer = localStorage.getItem('landingPageURL')
      if (!referrer) {
        localStorage.setItem('landingPageURL', document.documentURI)
      }
    }
  },
  components: {
    WhatsappConnect,
    ConsentBanner
  }
}
</script>
